module.exports = __webpack_public_path__ + "img/file.ba12778a.svg";